<template>
    <div class="popup" @click="closePopup">
        <div class="backdrop" />
        <span class="icon-close-white" @click="closePopup" />
        <div class="popup-content">
            <div class="popup-image-background" />
            <div class="popup-image" :class="image" />
            <div class="popup-image-banner" />
        </div>
    </div>
</template>
<script>
import EventBus from '@/shared/VueEvent';
export default {
    name: 'SuccessPopup',
    data() {
        return {
            noOfImages: 27,
            image: 'image-1'
        };
    },
    mounted() {
        this.randomImage();
    },
    methods: {
        closePopup() {
            EventBus.fire('toggleSuccessPopup', false);
            this.randomImage();
        },
        randomImage() {
            const rand = Math.floor(Math.random() * (this.noOfImages - 1) + 1);
            this.image = `image-${rand}`;
        }
    }
};
</script>
